module.exports = __webpack_public_path__ + "img/bubble_layout_1.95281b0e.svg";